import React, { useEffect, useState } from "react";
import { fetchQuestionPaperBySubjectApi } from "../../../services/service";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import useGateTestStyles from "../testStyle/gateStyle/gateTestStyle";

function QuestionPaper({ withAnswers = false, activeSubjectId }) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useGateTestStyles(); // Use the styles

  const fetchQuestionPaper = async () => {
    const examId = sessionStorage.getItem("examId");
    try {
      setLoading(true);
      const response = await fetchQuestionPaperBySubjectApi(
        examId,
        activeSubjectId
      );
      setQuestions(response.questions);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestionPaper();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "200px",
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="textSecondary">
          Loading question paper...
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {questions.map((question, qIndex) => (
        <Box
          sx={{ width: "100%", padding: 2, borderBottom: "1px solid #ccc" }}
          key={qIndex}
          mb={3}
        >
          {question.paragraph_en && (
            <div
            style={{marginBottom:'10px'}}
            >
              <p
              style={{ fontWeight: "bold", color: "black", marginBottom: "10px" }}
              >Paragraph</p>
              <div
                className={classes.img}
                dangerouslySetInnerHTML={{ __html: question.paragraph_en }}
              />
            </div>
          )}

          {/* paragraph_en */}

          {/* Question */}
          <p
            style={{ fontWeight: "bold", color: "black", marginBottom: "10px" }}
          >
            Question No. {qIndex + 1}
          </p>

          <div
            className={classes.img}
            dangerouslySetInnerHTML={{ __html: question.question_en }}
          />

          <Box
            style={{
              color: "black",
              display: "flex",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <div>
              Question Type: {question.question_type};
              {/* <span style={{ fontWeight: "bold", color: "black" }}>
                {question.question_type !== "Fill In The Blanks"
                  ? "MCQ"
                  : question.question_type}
                ;
              </span> */}
            </div>
            <div>
              Marks for correct answer:{" "}
              <span style={{ fontWeight: "bold", color: "green" }}>
                {question.mark};
              </span>
            </div>
            <div>
              Negative marks:{" "}
              <span style={{ fontWeight: "bold", color: "red" }}>
                {question.negative_mark}
              </span>
            </div>
          </Box>

          {/* Options */}
          {question.question_type !== "Fill In The Blanks" && (
            <Box display="flex" flexDirection="column" gap={1}>
              {question.options.map((option, oIndex) => (
                <Box
                  key={oIndex}
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{
                    "& img": {
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                    },
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    {oIndex + 1}
                  </span>{" "}
                  <Box dangerouslySetInnerHTML={{ __html: option.option_en }} />
                </Box>
              ))}
            </Box>
          )}

          {/* Correct Answers if withAnswers = yes */}
          {withAnswers === "yes" && (
            <div>
              {question.question_type !== "Fill In The Blanks" ? (
                <Box display="flex" flexDirection="column" gap={1}>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    Correct Answer
                  </span>{" "}
                  {question.options.map(
                    (option, oIndex) =>
                      option.correct_option && (
                        <Box
                          key={oIndex}
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{
                            "& img": {
                              width: "50px",
                              height: "50px",
                              objectFit: "contain",
                            },
                            display: "flex",
                            alignItems: "center",
                            paddingBottom: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold", color: "black" }}>
                            {oIndex + 1}
                          </span>{" "}
                          <Box
                            dangerouslySetInnerHTML={{
                              __html: option.option_en,
                            }}
                          />
                        </Box>
                      )
                  )}
                </Box>
              ) : (
                <Box style={{ fontWeight: "bold", color: "black" }}>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    Correct Answer
                  </span>{" "}
                  {question.options[0].solution_en}
                </Box>
              )}
            </div>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default QuestionPaper;
